import ActivityCardItem from "./ActivityCardItem"
import SliderNextArrow from "@modules/Common/components/SliderNextArrow"
import SliderPrevArrow from "@modules/Common/components/SliderPrevArrow"
import { PublicActivityPageQueriesQuery, StudentActivitiesQuery } from "@generated/graphql"
import { ActivitySliderWrapper, StyledBox, StyledBoxHeader, StyledOverlay } from "../styled/Activity"

interface Props {
  title: string
  description: string
  showButton?: "play" | "live"
  activities: StudentActivitiesQuery["studentActivities"] | PublicActivityPageQueriesQuery["publicChallengeActivities"] | PublicActivityPageQueriesQuery["publicLiveActivities"] | PublicActivityPageQueriesQuery["publicNewReleaseActivities"] | PublicActivityPageQueriesQuery["publicPopularActivities"]
}

export default function ActivitiesList({ title, description, activities, showButton }: Props) {
  const settings = {
    infinite: false,
    speed: 500,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
    slidesToShow: 4,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.2,
        },
      },
      {
        breakpoint: 625,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  }

  return (
    <>
      <StyledBox>
        <StyledBoxHeader>{title}</StyledBoxHeader>
        <img src="/assets/svg/activities-heading-big.svg" />
      </StyledBox>
      <StyledOverlay>
        <div style={{ fontWeight: 600, fontSize: "1.2rem" }} dangerouslySetInnerHTML={{ __html: description }} />
        <ActivitySliderWrapper {...settings}>
          {activities.map((activity) => <ActivityCardItem showButton={showButton} key={activity.id} item={activity} />)}
        </ActivitySliderWrapper>
      </StyledOverlay>
    </>
  )
}
